var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import styles from './App.css';
import WarningModal from '../../5_atoms/warningModal/WarningModal';
import { TimeoutModalTypes } from '../../constants/timeoutModalTypes';
import { fetchRefreshedToken } from '../../api/tokenAPI';
var App = forwardRef(function App(props, ref) {
    var tokenRef = useRef(props.token);
    var brokerConfigIdRef = useRef(props.brokerConfigId);
    var sessionTimeoutCallbackRef = useRef(props.sessionTimeoutCallback);
    var updateTokenCallbackRef = useRef(props.updateTokenCallback);
    var warningTimeoutIdRef = useRef(null);
    var sessionTimeoutIdRef = useRef(null);
    var _a = useState(false), modalVisible = _a[0], setModalVisible = _a[1];
    var _b = useState(null), modalType = _b[0], setModalType = _b[1];
    useEffect(function () {
        var _a;
        // An optional handler that is executed when the component has rendered
        (_a = props.onInitialized) === null || _a === void 0 ? void 0 : _a.call(props);
    }, [props.onInitialized]);
    useEffect(function () {
        setTimeouts();
        return function () {
            // Cleanup
            clearTimeouts();
        };
    }, []);
    useImperativeHandle(ref, function () {
        return {
            setSessionTimeoutCallback: function (callback) {
                sessionTimeoutCallbackRef.current = callback;
            },
            setUpdateTokenCallback: function (callback) {
                updateTokenCallbackRef.current = callback;
            },
            resetToken: function (brokerConfigId) {
                if (brokerConfigId) {
                    brokerConfigIdRef.current = brokerConfigId;
                }
                updateToken();
            }
        };
    }, []);
    function showModal(visible, type) {
        if (type === void 0) { type = null; }
        setModalVisible(visible);
        setModalType(type);
    }
    function clearTimeouts() {
        if (warningTimeoutIdRef.current) {
            clearTimeout(warningTimeoutIdRef.current);
        }
        if (sessionTimeoutIdRef.current) {
            clearTimeout(sessionTimeoutIdRef.current);
        }
    }
    function setTimeouts() {
        warningTimeoutIdRef.current = window.setTimeout(function () {
            showModal(true, TimeoutModalTypes.WARNING);
        }, props.warningTimeout);
        sessionTimeoutIdRef.current = window.setTimeout(function () {
            showModal(true, TimeoutModalTypes.SESSION);
        }, props.sessionTimeout);
    }
    function updateToken() {
        return __awaiter(this, void 0, void 0, function () {
            var tokenResponse;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        clearTimeouts();
                        return [4 /*yield*/, fetchRefreshedToken(props.apiDomain, brokerConfigIdRef.current, tokenRef.current)];
                    case 1:
                        tokenResponse = _b.sent();
                        if (!tokenResponse || tokenResponse.IsSessionExpired) {
                            showModal(true, TimeoutModalTypes.SESSION);
                        }
                        else {
                            tokenRef.current = tokenResponse.TokenString;
                            setTimeouts();
                            if (tokenRef.current) {
                                (_a = updateTokenCallbackRef.current) === null || _a === void 0 ? void 0 : _a.call(updateTokenCallbackRef, tokenRef.current);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    function handleWarningModalClick() {
        showModal(false);
        updateToken();
    }
    function handleSessionModalClick() {
        var _a;
        (_a = sessionTimeoutCallbackRef.current) === null || _a === void 0 ? void 0 : _a.call(sessionTimeoutCallbackRef);
    }
    return (_jsx("div", { className: styles.container, children: modalVisible && (modalType === TimeoutModalTypes.WARNING ?
            _jsx(WarningModal, { type: TimeoutModalTypes.WARNING, onClick: handleWarningModalClick, startTimeInSeconds: (props.sessionTimeout - props.warningTimeout) / 1000 }) :
            _jsx(WarningModal, { type: TimeoutModalTypes.SESSION, onClick: handleSessionModalClick })) }));
});
export default App;
